import React from "react";
import { Tag } from "antd";
import {StatementPaymentStatus} from "../../../../../../models/accounting/client-statements";

interface InvoicePaymentStatusProps {
    status: StatementPaymentStatus;
    large?: boolean;
}

export const statusColor: Record<StatementPaymentStatus, any> = {
    [StatementPaymentStatus.PAID]: "green",
    [StatementPaymentStatus.AWAITING]: "gold",
    [StatementPaymentStatus.OVERDUE]: "red",
    [StatementPaymentStatus.OVERPAID]: "red",

};

export const PaymentStatus: React.FC<InvoicePaymentStatusProps> = ({ status, large }) => {

    const color = statusColor[status];

    return (
        <Tag
            className={large ? "payment-status-large payment-status" : "payment-status"}
            color={color}
        >
            {status.capitalizeFirstLetter()}
        </Tag>
    );
};
